import { createSelector } from "@ngrx/store";
import { RootState } from "../root-reducers";

const usersSettingsState = (state: RootState) => state.usersSettings;

export const selectUsersSettingsUsersStorage = createSelector(
  usersSettingsState,
  (state): Record<string, boolean> => state.usersStorage.reduce((acc, { key, value }) => ({ ...acc, [key]: value }), {})
);
